<template>
    <div v-if="detailedThread" class="border-l flex flex-col">
        <UPageList class="text-sm flex-grow overflow-auto">
            <UPageCard
                :key="detailedThread.uuid + '_detailed' + ''"
                class="rounded-none"
                variant="ghost"
                :ui="{
                    container: 'sm:p-4'
                }"
            >
                <template #body>
                    <div v-for="(threadComment, index) in detailedThread.comments" :key="threadComment.uuid">
                        <resource-link-comment :value="threadComment.uuid" :comment="threadComment"/>
                        <USeparator v-if="index === 0" type="solid" class="my-2"/>
                    </div>
                </template>
            </UPageCard>
        </UPageList>

        <div class="w-full flex-shrink-0">
            <USeparator type="solid"/>
            <UFormField
                label="Svar"
                class="px-6 py-2"
            >
                <div class="flex justify-between gap-2">
                    <UInput
                        ref="commentInputRef"
                        v-model="commentBody"
                        variant="outline"
                        class="w-full"
                        placeholder="Svar..."
                        @keydown.enter="handleSave"
                    />
                    <UButton
                        :disabled="commentBody.length == 0"
                        color="primary"
                        @click="handleSave"
                    >
                        Send
                    </UButton>
                </div>
            </UFormField>
        </div>
    </div>
</template>

<script setup lang="ts">

import {CommentThread} from '@/comment/comment.service'
import {computed, nextTick, ref, watch} from 'vue'
import ResourceLinkComment from '@/comment/ResourceLinkComment.vue'

const emit = defineEmits(['createComment'])

const detailedThread = defineModel<CommentThread>('detailedThread')

const commentInputRef = ref(null)

const commentBody = ref('')
const comment = computed(() => ({
    body: commentBody.value,
    thread: detailedThread.value?.uuid
}))

const handleSave = () => {
    if (!comment.value.thread || comment.value.body === '') return

    emit('createComment', comment.value)
    commentBody.value = ''
}

watch(detailedThread, (newValue) => {
    if (newValue) {
        nextTick(() => {
            if (commentInputRef.value) {
                //@ts-ignore
                const nativeInputElement = commentInputRef.value.input
                if (nativeInputElement) nativeInputElement.focus()
            }
        })
    }
}, {immediate: true})

watch(detailedThread, () => {
    nextTick(() => {
        const latestComment = detailedThread.value?.comments[detailedThread.value.comments.length - 1]
        if (!latestComment) return

        const element = document.querySelector(`[value="${latestComment.uuid}"]`)
        element?.scrollIntoView()
    })
})

</script>

<style scoped>

</style>